import { gql } from '@apollo/client'

import { LOCATION_FRAGMENT } from '../fragments'

export const GET_CURRENT_LOCATION = gql`
  query CurrentLocation {
    currentLocation {
      ...Location
    }
  }
  ${LOCATION_FRAGMENT}
`
